export default __webpack_public_path__ + "static/media/bb.26c9a5ae.svg";